import React, { useContext, useEffect, useState } from 'react';
import { Avatar, Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Typography, IconButton,Button} from '@mui/material';
import { Search as SearchIcon, ArrowBack as ArrowBackIcon, ArrowForward as ArrowForwardIcon } from '@mui/icons-material';
import axios from 'axios';
import { ContextData } from '../../../context/Context';
import baseUrl from '../../../BaseURL'; 
import AddUserDialog from '../Contents/AdminUser/AddAdminUserDialog';
import { toast } from 'react-toastify';
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const AdminUsers = () => {

  
  const [searchText, setSearchText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData,setStudentData] = useState(null)
  const [CountData,setCountData] = useState(0)
  const rowsPerPage = 6;
  const {setLoader,accesstoken,Refresh,setRefresh} = useContext(ContextData)


  useEffect(()=>{
      

      async function FetchData(){
              //  setLoader(true)  

            try {
              const response = await axios.get(`${baseUrl}/auth/get_data_adminuser`,{
                withCredentials: true,
                headers: {
                  'Accept' : 'application/json',
                  'authorization': `Bearer ${accesstoken !== null && accesstoken}`
                }}) 

              setCountData(Object.keys(response.data))
              setStudentData(response.data)
             
             
            } catch (err) {
               if(err) console.log(err.message)
              // setLoader(false)
            }

           
      }FetchData()


  },[Refresh])

  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };


  
    const List =  Object.keys(StudentData !== null && StudentData).map(data=> StudentData[data])
    const filteredUsers = List.filter(user => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return (
     ( 
      user.fname.toLowerCase().includes(lowerCaseSearchText) &&   user.lname.toLowerCase().includes(lowerCaseSearchText) ) ||
      user.mobile.toLowerCase().includes(lowerCaseSearchText) ||
      user.usertype.toLowerCase().includes(lowerCaseSearchText) ||
      user.email.toLowerCase().includes(lowerCaseSearchText)
      // Add more fields for search if needed (e.g., state, phone number)
    );



  });

  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage(prevPage => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage(prevPage => prevPage - 1);
  };

  const HanldeRemove = async (sttokens) =>{

    
    try {
      const response = await axios.delete(`${baseUrl}/auth/remove_adminuser_user/${sttokens}`,{
        withCredentials: true,
        headers: {
          'Accept' : 'application/json',
          'authorization': `Bearer ${accesstoken !== null && accesstoken}`
        }}).then(res=>{
              
            if(res.data.status){
               
                    toast.success(res.data.statusText)
                     setRefresh(!Refresh)

            }

        })
          } catch (err) {

       if(err) console.log(err.message)
      
       }


       

  }



  return (
    <div style={{width:"100%",height:"100%"}}>
    <Container
    >
      <Typography variant="h4" gutterBottom className='flex justify-between items-center'>
        <p className='font-extrabold mt-3'>Admin Users</p>
        <div>
          
      <AddUserDialog />
        </div>
      </Typography>
      
      <TextField
        label="Search"
        variant="outlined"
        value={searchText}
        onChange={handleSearchChange}
        InputProps={{
          endAdornment: (
             <IconButton>
              <SearchIcon />
             </IconButton>
          ),
        }}
        fullWidth
        margin="normal"
      />
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{background:"rgb(0, 24, 69)"}}>
            <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>No</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Full Name</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Email</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Mobile</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Usertype</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Access Level</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Restrict</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Time</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Date</TableCell>
              <TableCell align='center' sx={{color:"white",fontWeight:"800"}}>Remove</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersToShow.map((user,index) => (
              <TableRow key={user.id}> 
               <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{index + 1}</TableCell>
               {/*  <TableCell>
                  <Avatar sx={{boxShadow:'2px 2px 10px rgba(0,0,0,0.364)'}} alt={user.fname} src={`https://example.com/avatars/${user.id}.png`} />
                </TableCell> */}
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.fname} {user.lname}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.email}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.mobile}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.usertype}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.acc_level}%</TableCell>

                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.acc_lock.toString() === "0" ?
                
                <Button className='Hover-'  elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                   Lock
                 </Button>
                            :
                 <Button className='Hover-'  elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(179, 103, 21)', margin:'9px 0px'}}  size="large" variant="contained">
                   Unlock
                </Button>
                }
                </TableCell>

                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.insertDate.slice(user.insertDate.indexOf("T") + 1)}</TableCell>
                <TableCell align='center' sx={{whiteSpace:"nowrap"}}>{user.insertDate.slice(0,user.insertDate.indexOf("T"))}</TableCell>
               
               
           
                 {/*  <TableCell>
                   <EditStudentPop/>
                  </TableCell> */}
 
                  <TableCell>

                <Button className='Hover-' onClick={()=> HanldeRemove(user.token)} elevation={10} sx={{whiteSpace: 'nowrap' , fontSize: '14px', backgroundColor:'rgb(199, 1, 1)', margin:'9px 0px'}}  size="large" variant="contained">
                   Remove
                 </Button>

                  </TableCell> 
                  
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {totalPages > 1 && (
        <div>
          {currentPage > 1 && (
            <IconButton onClick={handlePrevPage}>
              <ArrowBackIcon />
            </IconButton>
          )}
          <span>Page {currentPage} of {totalPages}</span>
          {currentPage < totalPages && (
            <IconButton onClick={handleNextPage}>
              <ArrowForwardIcon />
            </IconButton>
          )}
        </div>
      )}
    </Container>
    </div>
  );
};

export default AdminUsers;


// 